import React from 'react';
import ReactDOM from 'react-dom';
import { T } from '../../../../common/locale/translate';

export default class Tabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: this.props.activeIndex,
      value: this.props.offerType,
      class_name: this.props.class_name || 'custom_select',
      title: this.props.title || 'Select',
      name: T('holiday'),
      active: false
    };

    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    this.setState({
      value: this.props.offerType,
      activeIndex: this.props.activeIndex
    });
    document.addEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.activeIndex !== this.state.activeIndex) {
      this.setState({
        activeIndex: nextProps.activeIndex,
        name: this.setInitialState(nextProps.activeIndex)
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
  }

  render() {
    return (
      <div>
        <ul
          className="tabs-wrapper"
          ref={() => {
            this.returnSearchedValue = this.returnSearchedValue.bind(this);
          }}
        >
          {this.props.children.map((elem, i) => {
            let state = i == this.state.activeIndex ? true : false;
            return (
              <elem.type
                {...elem.props}
                active={state}
                handleTabChange={this.handleTabChange}
                index={i}
                key={i}
                mobile={false}
              />
            );
          })}
        </ul>
        {this.props.renderDropdown && (
          <div
            className={`mobile-tabs-wrapper ${
              this.state.class_name
            } select-wrapper animated-text-form ${
              this.state.active ? 'active' : ''
            }`}
          >
            <label className="animated-text-label">
              <span className="animated-text-label-name" />
            </label>
            <i className="dropdown-icon fa fa-chevron-down" />
            <input
              type="text"
              value={this.state.name}
              className="animated-text-input"
              placeholder=""
              readOnly
              onClick={this.handleClick}
            />
            <ul className="dropdown-menu">
              {this.props.children.map((elem, i) => {
                let state = i == this.state.activeIndex ? true : false;
                return (
                  <elem.type
                    {...elem.props}
                    active={state}
                    handleTabChange={this.handleTabChange}
                    index={i}
                    key={i}
                    mobile={true}
                    class_name={
                      elem.props.class_name
                        ? elem.props.class_name
                        : this.state.class_name
                    }
                  />
                );
              })}
            </ul>
          </div>
        )}
      </div>
    );
  }

  handleTabChange = (index, type, value, name) => {
    this.setState({ activeIndex: index, value: value, name, active: false });
    this.props.handleTabChange(value, index);
  };

  handleClose = () => this.setState({ active: false });

  handleFocus = () => this.setState({ active: true });

  setInitialState = index => {
    let filterName = T('holiday');
    this.props.children.map((elem, i) => {
      if (i == index) {
        filterName = elem.props.name;
      }
    });
    return filterName;
  };

  handleClick = () => this.setState({ active: !this.state.active });

  handleClickOutside = event => {
    const domNode = ReactDOM.findDOMNode(this);
    if (!domNode || !domNode.contains(event.target)) {
      this.setState({ active: false });
    }
  };

  returnSearchedValue = () => this.state.value;
}



// WEBPACK FOOTER //
// ./app/javascript/common/components/tabs.js